// extracted by mini-css-extract-plugin
module.exports = {"container":"newsletter-pop-up_container__N0sj4","dialog":"newsletter-pop-up_dialog__Tf_yl","closeButton":"newsletter-pop-up_closeButton__Wk_Tu"};